// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1wYAh","info":"PatientInfo_info__1qI43"};